import type { FC, ReactNode } from "react";
import { EditableMetricCard, type EditableMetricController } from "../../../patterns/metric-card";
import { HISTORY_CARD_LABEL_CLASS } from "./cardStyles";

const READ_ONLY_CONTROLLER: EditableMetricController = {
	isEditing: false,
	canSubmit: false,
	mutationError: null,
	startEditing: () => {},
	cancelEditing: () => {},
	submit: () => {},
	dismissError: () => {},
};

export type HistoryReadOnlyCardProps = {
	testId: string;
	label: string;
	/** Formatted display value. */
	children: ReactNode;
	/** Optional context rendered beneath the value. */
	caption?: ReactNode;
};

/** Display-only metric tile for derived values shown alongside the editable cards. */
export const HistoryReadOnlyCard: FC<HistoryReadOnlyCardProps> = ({
	testId,
	label,
	children,
	caption,
}) => (
	<EditableMetricCard
		testId={testId}
		label={label}
		labelClassName={HISTORY_CARD_LABEL_CLASS}
		readOnly
		controller={READ_ONLY_CONTROLLER}
	>
		<EditableMetricCard.ValueRow data-testid={`${testId}-display`}>
			<EditableMetricCard.Value size="sm">{children}</EditableMetricCard.Value>
		</EditableMetricCard.ValueRow>
		{caption && <EditableMetricCard.Caption>{caption}</EditableMetricCard.Caption>}
	</EditableMetricCard>
);
